import { Box, BoxProps } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ProgressBoxStyleMobile = styled(Box)<
  BoxProps & { progress:number }
>(({ theme,progress }) => ({
  alignItems: "center",
  backgroundImage:
    `linear-gradient(to right, ${theme.customColors.backgroundPrimaryCta} ${progress}%, `
    + `${theme.customColors.backgroundDisabled} ${progress}%)`,
  borderRadius: "8px",
  cursor:"pointer",
  display: "flex",
  height: "40px",
  justifyContent: "center",
  overflow: "hidden",
  padding: "0 16px",
  width:"fit-content"
}));

export const IconBoxStyleMobile = styled(Box)(() => ({
  alignItems:"center",
  display:"flex",
  flexShrink:0,
  height:"16px",
  justifyContent:"center",
  width:"16px"
}));
